"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const merlin_info_panels_1 = require("@travelnest/merlin.info-panels");
const __1 = require("../../../..");
const TaskPage_1 = require("../../base/TaskPage");
const Paragraph_1 = require("../../../components/paragraph/Paragraph");
const Section_1 = require("../../../components/section/Section");
const Button_1 = require("../../../components/button/Button");
const ChannelUnavailable_1 = require("../../../components/channel-unavailable/ChannelUnavailable");
const CheckedAccordion_1 = require("../../../components/checked-accordion/CheckedAccordion");
const ChannelIcon_1 = require("../../../components/icon/ChannelIcon");
const autosave_1 = require("../../../../hooks/autosave");
const viewstate_1 = require("../../../../entities/viewstate");
const constants_1 = require("../../../../entities/contracts/constants");
const helpers_1 = require("./helpers");
const constants_2 = require("../../../../tasks/constants");
const ValidationContext_1 = require("../../../../context/ValidationContext");
const HorizontalRule_1 = require("../../../components/horizontal-rule/HorizontalRule");
const Spacer_1 = require("../../../components/spacer/Spacer");
const TaskCompletenessContext_1 = require("../../../../context/TaskCompletenessContext");
const types_1 = require("../../../../entities/fact/types");
const MarginWrapper_1 = require("../../../components/margin/MarginWrapper");
const styled_1 = __importDefault(require("@emotion/styled"));
const react_redux_1 = require("react-redux");
const selectors_1 = require("../../../../entities/commission/selectors");
const HelpLink_1 = require("../../../components/help-link/HelpLink");
const StyledPanelSuffix = styled_1.default.span `
	font-weight: 900;
	font-size: 1.375rem;
`;
// Validation in this context is one channel selected for listing
const oneLiveChannelSelected = (contracts) => {
    const sellContract = contracts
        .filter((c) => c.channel_id !== constants_1.Channel.TRAVELNEST)
        .find((c) => c.list_property);
    return !!sellContract;
};
exports.default = (props) => {
    const { customerId } = React.useContext(__1.AppContext);
    const { property, viewState: propertyViewState } = (0, autosave_1.useAutoSaveProperty)(props.propertyId);
    const isLegacyCommission = (0, react_redux_1.useSelector)((state) => (0, selectors_1.customerIsLegacyCommission)(state, customerId));
    const { listingContracts, viewState: contractsViewState, update, lastSaved, updaterError, getterError } = (0, autosave_1.useAutoSaveListingContracts)(props.customerId);
    const [totalSelected, setTotalSelected] = React.useState(0);
    const selectAllAvailableChannels = () => update((0, helpers_1.toggleChannelSelection)('all', listingContracts, customerId).filter((contract) => !(0, helpers_1.isExpediaFranceOrSpain)(contract.channel_id, property)));
    // On page load, if task completion is INPUT_REQUIRED and we have no listing contracts, select all by default
    const { state: taskCompletenessState } = React.useContext(TaskCompletenessContext_1.TaskCompletenessContext);
    React.useEffect(() => {
        if (taskCompletenessState.CHANNEL_SELECTION.completion === types_1.TaskCompletionState.INPUT_REQUIRED
            && listingContracts !== null && listingContracts !== undefined && listingContracts.length === 0) {
            selectAllAvailableChannels();
        }
    }, [listingContracts]);
    const { state: validationState, dispatch: validationDispatch } = React.useContext(ValidationContext_1.ValidationContext);
    React.useEffect(() => {
        if (listingContracts) {
            const valid = oneLiveChannelSelected(listingContracts);
            const existing = validationState.channels.valid;
            if (valid !== existing) {
                validationDispatch(ValidationContext_1.validationActions.updateChannels(valid));
            }
        }
    }, [listingContracts]);
    React.useEffect(() => {
        const totalChannels = (0, helpers_1.getChannelsCount)(listingContracts);
        setTotalSelected(totalChannels);
    }, [listingContracts]);
    return (React.createElement(TaskPage_1.TaskPage, { task: constants_2.Tasks.CHANNEL_SELECTION, property: property, viewState: (0, viewstate_1.combineViewStates)(contractsViewState, propertyViewState), lastSaved: lastSaved, getterError: getterError, updaterError: updaterError },
        React.createElement(TaskPage_1.TaskLayout, null,
            React.createElement(HorizontalRule_1.HorizontalRule, null),
            React.createElement(Spacer_1.Spacer, { spacing: "large" }),
            React.createElement(TaskPage_1.TaskColumn, null,
                React.createElement(Section_1.Section, { heading: "Helping you reach more guests" },
                    React.createElement(Spacer_1.Spacer, { spacing: "small" }),
                    React.createElement(Paragraph_1.Paragraph, { fillParent: "mid" }, "We'll boost your exposure so you'll be seen by millions of guests. We work with 6 core partner channels and 20+ well-known affiliate sites."),
                    React.createElement(Spacer_1.Spacer, { spacing: "small" })),
                React.createElement(MarginWrapper_1.MarginWrapper, null,
                    React.createElement(Spacer_1.Spacer, { spacing: "small" }),
                    React.createElement(merlin_info_panels_1.StatisticPanel, { label: "You'll go live on:", value: React.createElement(React.Fragment, null,
                            React.createElement(merlin_info_panels_1.StatisticPanelValue, null, totalSelected),
                            React.createElement(StyledPanelSuffix, null,
                                ' ',
                                "channels \uD83D\uDE4C")), subtext: isLegacyCommission ? '' : 'All Channel Fees are 15%, plus 5% Travelnest Fee', colour: 'green' }),
                    React.createElement(Spacer_1.Spacer, { spacing: 'small' }),
                    React.createElement(Button_1.Button, { onClick: selectAllAvailableChannels }, "Select all channels"),
                    React.createElement(Spacer_1.Spacer, null),
                    React.createElement(HelpLink_1.HelpLink, { to: "https://travelnest.freshdesk.com/support/solutions/articles/101000365068-choosing-your-channels" }, "How to manage my channel selection?"),
                    React.createElement(Spacer_1.Spacer, null),
                    React.createElement(Paragraph_1.Paragraph, { fillParent: "mid" }, "You can update your channel selection at any time."),
                    React.createElement(Spacer_1.Spacer, null)))),
        React.createElement(TaskPage_1.TaskLayout, null,
            React.createElement(TaskPage_1.TaskColumn, { width: 50 }, constants_1.CHANNELS.slice(0, 3).map((c) => ((0, helpers_1.isExpediaFranceOrSpain)(c.id, property) ?
                React.createElement(ChannelUnavailable_1.ChannelUnavailable, { key: c.id, heading: c.display_name, subheading: (0, helpers_1.getSubHeading)(c.affiliates.length), icon: () => React.createElement(ChannelIcon_1.ChannelIcon, { channel: c.id }), link: c.marketingLink }, 'Expedia no longer lists properties located in France and Spain. We cannot list your property on Expedia or any Expedia affiliate sites.')
                :
                    React.createElement(CheckedAccordion_1.CheckedAccordion, { key: c.id, heading: c.display_name, subheading: (0, helpers_1.getSubHeading)(c.affiliates.length), icon: () => React.createElement(ChannelIcon_1.ChannelIcon, { channel: c.id }), onChange: () => update((0, helpers_1.toggleChannelSelection)(c.id, listingContracts, customerId)), link: c.marketingLink, checked: (0, helpers_1.getCheckedValue)(c.id, listingContracts) },
                        c.affiliates.map((aff) => React.createElement("div", { key: aff }, aff)),
                        c.detail)))),
            React.createElement(TaskPage_1.TaskColumn, { width: 50 }, constants_1.CHANNELS.slice(3).map((c) => {
                return c.id === constants_1.Channel.TRAVELNEST
                    ? (React.createElement(ChannelUnavailable_1.ChannelUnavailable, { key: c.id, heading: c.display_name, subheading: (0, helpers_1.getSubHeading)(c.affiliates.length), icon: () => React.createElement(ChannelIcon_1.ChannelIcon, { channel: c.id }), link: c.marketingLink }))
                    : ((React.createElement(CheckedAccordion_1.CheckedAccordion, { key: c.id, heading: c.display_name, subheading: (0, helpers_1.getSubHeading)(c.affiliates.length), icon: () => React.createElement(ChannelIcon_1.ChannelIcon, { channel: c.id }), onChange: () => update((0, helpers_1.toggleChannelSelection)(c.id, listingContracts, customerId)), link: c.marketingLink, checked: (0, helpers_1.getCheckedValue)(c.id, listingContracts) },
                        c.affiliates.map((aff) => React.createElement("div", { key: aff }, aff)),
                        c.detail)));
            })))));
};
//# sourceMappingURL=MarketingChannelsPage.js.map